import * as angular from "angular";
import {IController} from 'angular';

export class BringozPackageSelectItemComponent implements IController {

  id: any;
  onSelect: Function;

  constructor() {}

  $onInit() {

  };


}

angular
  .module('bringoz.admin.commons')
  .component('bringozPackageSelectItem', {
    bindings: {
      id: '<',
      isExcluded: '<?'
    },
    template: require('./bringoz-package-select-item.html').default,
    controller: BringozPackageSelectItemComponent
  });
